import { Theme } from '@mui/material';

export default {
  components: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        padding: theme.spacing(2, 2.5)
      })
    }
  }
};
